import React from "react";
import { Link } from "react-router-dom";
import { useSelector, RootStateOrAny } from "react-redux";
import IUserInfo from "../components/pages/models/interfaces/IUserInfo";
export default function TopBar() {
  let identity: IUserInfo = JSON.parse(useSelector((state: RootStateOrAny) => state.portalData.identity));
  return (
    <div className="top">
      <div className="container">
        <div className="row">
          <div className="col-md-12" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div className="col-md-6">
              <ul className="flat-infomation">
                <li className="email"><a onClick={() => window.location.href='mailto:aportal@gpfalliance.com'} style={{cursor:"pointer"}}>aportal@gpfalliance.com</a></li>
              </ul>
            </div>
            <div className="col-md-6">
              {
                identity !== null ?
                  <div className="flat-questions">
                    <span style={{ fontSize: 14 }}>Welcome: <span>{identity.name}</span></span>
                  </div>
                  :
                  null
              }
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};